// extracted by mini-css-extract-plugin
export default {"back":"Actions_back__vqivG","white":"Actions_white__Ypztz","black":"Actions_black__eA9zg"};